import _ from 'lodash'
import KeyValuePair from '@/modules/core/support/KeyValuePair'
import { Level } from '@/modules/log'

/**
 * Entrada del log
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Entry {
    public readonly id = _.uniqueId('log_')
    public readonly timestamp = _.now()
    private _level: Level
    private _message = ''
    private _context: KeyValuePair = {}

    constructor (level: Level, message: string, context: KeyValuePair = {}) {
        this._level = level
        this._message = message
        this._context = context
    }

    get level (): Level {
        return this._level
    }

    get message (): string {
        return this._message
    }

    get context (): KeyValuePair {
        return _.clone(this._context)
    }
}
